import { useMutation } from 'react-query';
import {
  createClipEscolaIntegrationAsync,
  deleteClipEscolaIntegrationAsync,
  getAllClipEscolaIntegrationsAsync,
  getClipEscolaIntegrationByIdAsync,
  updateClipEscolaIntegrationAsync,
} from '../../index';

export const useCreateClipEscolaIntegrationAsync = () =>
  useMutation(createClipEscolaIntegrationAsync);

export const useGetClipEscolaIntegrationByIdAsync = () =>
  useMutation(getClipEscolaIntegrationByIdAsync);

export const useGetAllClipEscolaIntegrationsAsync = () =>
  useMutation(getAllClipEscolaIntegrationsAsync);

export const useUpdateClipEscolaIntegrationAsync = () =>
  useMutation(updateClipEscolaIntegrationAsync);

export const useDeleteClipEscolaIntegrationAsync = () =>
  useMutation(deleteClipEscolaIntegrationAsync);
